import { RootState } from 'renderer/shared/state/store';

export const selectUsersTableQuery = (state: RootState) => state.usersTable;
